export * from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./selPay.vue?vue&type=template&id=2fb10366&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/Payment/selPay.vue?vue&type=template&id=2fb10366&scoped=true
// module id = 257
// module chunks = 0